var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["NOT_PAID"] = 0] = "NOT_PAID";
    PaymentStatus[PaymentStatus["PAID"] = 1] = "PAID";
    PaymentStatus[PaymentStatus["PARTIALLY_PAID"] = 2] = "PARTIALLY_PAID";
    PaymentStatus[PaymentStatus["PENDING_TO_PROCESS"] = 8] = "PENDING_TO_PROCESS";
})(PaymentStatus || (PaymentStatus = {}));
export default PaymentStatus;
